// extracted by mini-css-extract-plugin
export default {"IconButton":"add-column-header-module__IconButton--bIDmf","DisabledButton":"add-column-header-module__DisabledButton--RK55R"};